import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigation } from "react-router-dom";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/Footer";
import Loader from "./Loader";

function AppLayout() {
  const location = useLocation();
  const { state } = useNavigation();
  const isLoading = state === "loading";
  // console.log("Navigation: ", isLoading);
  const { hash, pathname, search } = location;
  const isHomepage = pathname === "/";

  useEffect(() => {}, [pathname]);

  // console.log("Params: ", JSON.stringify(isHomepage));
  return (
    <div className=" bg-primary">
      {isLoading && <Loader />}
      <div className="navbar">
        <Navbar />
      </div>
      <div
        className={`
          outlet grid w-full ${isHomepage ? `pt-0` : `pt-16`}`}
      >
        <Outlet />
      </div>
      <div className="footer">
        <Footer />
      </div>
    </div>
  );
}

export default AppLayout;
